import { Controller } from "@hotwired/stimulus";
import html from "html-template-tag";

export default class extends Controller {
  static targets = ["pairedField"];

  declare pairedFieldTargets: HTMLElement[];

  connect() {
    super.connect();

    this.prepareControls();
    this.prepareMatchState();
  }

  copyField(event: Event) {
    const element = event.currentTarget;

    if (element instanceof HTMLElement) {
      const leftInput = element.previousElementSibling?.querySelector('input') || element.previousElementSibling?.querySelector('textarea');
      const rightInput = element.nextElementSibling?.querySelector('input') || element.nextElementSibling?.querySelector('textarea');

      const leftSelect = element.previousElementSibling?.querySelector('select');
      const rightSelect = element.nextElementSibling?.querySelector('select');

      if (leftInput && rightInput) {
        rightInput.value = leftInput.value;
      }

      if (leftSelect && rightSelect) {
        const selectedLeft = Array.from(leftSelect.querySelectorAll("option")).find(o => o.selected);

        rightSelect.querySelectorAll("option").forEach((opt) => {
          opt.selected = opt.value === selectedLeft?.value;
        });
      }
    }
  }

  private prepareMatchState() {
    this.pairedFieldTargets.forEach((pairedField) => {
      const inputs = [...Array.from(pairedField.querySelectorAll('input')), ...Array.from(pairedField.querySelectorAll('textarea'))];
      const selects = pairedField.querySelectorAll('select');

      if (inputs.length == 2) {
        const left = inputs[0];
        const right = inputs[1];

        if (left.value == right.value) {
          right.classList.add("original-match");
        }
      }

      if (selects.length == 2) {
        const left = selects[0];
        const right = selects[1];

        const selectedLeft = Array.from(left.querySelectorAll("option")).find(o => o.selected);
        const selectedRight = Array.from(right.querySelectorAll("option")).find(o => o.selected);

        if (selectedLeft && selectedRight && selectedLeft.value == selectedRight.value) {
          right.classList.add("original-match");
        }
      }
    });
  }

  private prepareControls() {
    const action = document.createElement('span');
    action.classList.add('button', 'mr-3');
    action.dataset['action'] = 'click->application-comparison#copyField';
    action.innerHTML = html`<span class="fas fa-caret-right"></span>`;

    this.pairedFieldTargets.forEach((pairedField) => {
      const control = pairedField.querySelector('.control + .control');

      if (control) {
        control.parentNode!.insertBefore(action.cloneNode(true), control);
      }
    });
  }
}
